import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<mask id=\"mask0_ar\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"20\" height=\"20\"><circle cx=\"10\" cy=\"10\" r=\"10\" fill=\"#D9D9D9\"></circle></mask><g mask=\"url(#mask0_ar)\"><rect width=\"20\" height=\"6.67\" fill=\"#000000\"></rect><rect y=\"6.67\" width=\"20\" height=\"6.67\" fill=\"#ffffff\"></rect><rect y=\"13.33\" width=\"20\" height=\"6.67\" fill=\"#009639\"></rect><polygon points=\"0,0 7,10 0,20\" fill=\"#ce1126\"></polygon></g>", 2)
  ])))
}
export default { render: render }